import axios from "./axios";

export const listProfiles = async () => {
  try {
    const data = await axios.get("/api/v1/provision/profile");
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getProfile = async (profile) => {
  try {
    const data = await axios.get(`/api/v1/provision/profile/${profile}`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const createProfile = async (data) => {
  try {
    var name = data.name;
    delete data.name;
    const response = await axios.put(`/api/v1/provision/profile/${name}`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    return { status: "error", error };
  }
};

export const updateProfile = async (profile, data) => {
  try {
    const response = await axios.post(`/api/v1/provision/profile/${profile}?op=update`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    return { status: "error", error };
  }
};

export const deleteProfile = async (profile) => {
  try {
    const response = await axios.delete(`/api/v1/provision/profile/${profile}`);
    return response;
  } catch (error) {
    return { status: "error", error };
  }
};
export const exportProfile = async (profile) => {
  try {
    const response = await axios.get(`/api/v1/provision/profile/${profile}?op=export`, {responseType: 'blob'});
    return response;
  } catch (error) {
    return { status: "error", error };
  }
};

export const importProfile = async (data) => {
  try {
    const response = await axios.post(`/api/v1/provision/profile?op=import`, data,{
      headers: {
        "Content-Type": "multipart/form-data"
      },
    });
    return response;
  } catch (error) {
    return { status: "error", error };
  }
};